import { render, staticRenderFns } from "./ViewSensitive.vue?vue&type=template&id=dbe8c6ea&scoped=true&"
import script from "./ViewSensitive.vue?vue&type=script&lang=js&"
export * from "./ViewSensitive.vue?vue&type=script&lang=js&"
import style0 from "./ViewSensitive.vue?vue&type=style&index=0&id=dbe8c6ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe8c6ea",
  null
  
)

export default component.exports